import type { GetServerSideProps, NextPage } from "next"
import Image from "next/image"
import { NavBar } from "../../src/components/universal/NavBar"
import { Footer } from "../../src/components/universal/Footer"
import { PageMeta } from "../../src/components/universal/PageMeta"
import { DecodedStoreLink, decodeStoreLink } from "../../src/utils/decodeLink"

import Link from "next/link"
import { DownloadCTA } from "../../src/components/universal/DownloadCTA"
import { storesList } from "../../src/stores"

//Images
type Props = {
  store: DecodedStoreLink
}

const Store: NextPage<Props> = ({ store }) => {
  return (
    <div>
      <PageMeta
        title={store.name}
        theme={"#F3F4F7"}
        description={"Download Ruby apps for iOS and Android."}
      ></PageMeta>

      <main>
        <NavBar />

        <section>
          <div className='wrapper store-details'>
          <div className='image-wrapper'>
              <img src={store.logo} alt='' />
            </div>
            <div className='details flex-col'>
              <h1>{store.name}</h1>
              <p className="callout gray-text">{store.category}</p>
              <p className='callout accent'>{store.number_of_coupon_codes} Coupon codes available</p>

              <p>{store.terms}</p>

              <Link href={"https://shopruby.onelink.me/Lu2f/pdofxddt"}>
                <button className='btn-lg-label bg-primary secondary'>
                  Visit store on Ruby
                </button>
              </Link>
            </div>

           
          </div>
        </section>

        <section>
          <div className='wrapper'>
            <DownloadCTA />
          </div>
        </section>

        <Footer />
      </main>
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { storeId } = context.query
  if (!storeId) {
    return {
      notFound: true,
    }
  }

  const encodedUrls = storesList

  let store: DecodedStoreLink | null = null

  encodedUrls.forEach((el) => {
    const res = decodeStoreLink(el)
    if (res && res.slug == storeId) {
      store = res
    }
  })

  if (store) {
    return {
      props: {
        store,
      },
    }
  } else {
    return {
      notFound: true,
    }
  }
}

export default Store
